import { render, staticRenderFns } from "./StepsSecondCourse.vue?vue&type=template&id=139be7de&scoped=true"
import script from "./StepsSecondCourse.vue?vue&type=script&lang=js"
export * from "./StepsSecondCourse.vue?vue&type=script&lang=js"
import style0 from "./StepsSecondCourse.vue?vue&type=style&index=0&id=139be7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139be7de",
  null
  
)

export default component.exports